import Icon from '../components/Icon.vue'

Icon.register({"server":{"width":1792,"height":1792,"paths":[{"d":"M128 1408h1024v-128h-1024v128zM128 896h1024v-128h-1024v128zM1696 1344q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM128 384h1024v-128h-1024v128zM1696 832q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1696 320q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1792 1152v384h-1792v-384h1792zM1792 640v384h-1792v-384h1792zM1792 128v384h-1792v-384h1792z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/server.js
// module id = 1796
// module chunks = 0